var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerified = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 56,
    viewBox: "0 0 51 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.888942 8.66667L25.5556 0L49.5556 8.66667C49.5556 8.66667 51.5548 22 49.5556 29.3333C47.5564 36.6667 47.5564 37.3333 42.2223 44.6667C37.8422 50.6884 25.5556 56 25.5556 56C25.5556 56 13.5403 50.4813 8.88894 44.6667C3.55599 38 2.88932 36.6667 0.888942 29.3333C-1.11144 22 0.888942 8.66667 0.888942 8.66667Z",
    fill: "#25CC73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2222 0L49.2222 8.66667C49.2222 8.66667 51.2214 22 49.2222 29.3333C47.2229 36.6667 47.2229 37.3333 41.8888 44.6667C37.5088 50.6884 25.2222 56 25.2222 56V0Z",
    fill: "#0EB36A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1086 16.8863C37.5718 17.2426 37.6585 17.907 37.3022 18.3703L24.0823 35.556C23.563 36.2311 22.5685 36.2957 21.9662 35.6934L14.5326 28.2598C14.1193 27.8466 14.1193 27.1765 14.5326 26.7632V26.7632C14.9459 26.35 15.6159 26.35 16.0292 26.7632L22.8947 33.6287L35.6246 17.0798C35.9809 16.6166 36.6453 16.5299 37.1086 16.8863V16.8863Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/verified.b0137f1b9160f3515393727ea01c12c5.svg";